import {
	DynamicPermissionCode,
	TwoFactorAuthorizationStatus
} from 'Services/Api/Users/Types';
import Layout from './Layout';
import { useTranslation } from 'react-i18next';
import { Permission } from 'Components';
import { EditUserValues } from 'Pages/User/User.types';
import { useFormikContext } from 'formik';
import ModuleSettingsContainer, {
	useJobClass
} from 'Pages/User/EditUser/tabs/ModuleSettings/ModuleSettingsContainer';
import { useModuleSettings } from 'Pages/User/EditUser/EditUser.hooks';
import { JobClassField, UserRoleField } from 'Pages/User/components';
import { getLMSModuleSettingErrorText } from 'Pages/User/EditUser/tabs/ModuleSettings/ModuleSettings.helpers';

type Props = {
	isProfile: boolean;
};
const ModuleSettings = ({ isProfile }: Props) => {
	const { t } = useTranslation();
	const {
		onJobClassChange,
		onUserRoleChange,
		onDisabled
	} = useModuleSettings();
	const { values, errors } = useFormikContext<EditUserValues>();
	const { loading, data } = useJobClass({ values });

	return (
		<Layout
			title={t(`profile.moduleSettings.title`)}
			description={t(`profile.moduleSettings.description`)}
		>
			<ModuleSettingsContainer values={values} onDisabled={onDisabled}>
				{(disabled) => (
					<>
						<JobClassField
							value={values.moduleSettings?.jobClassId}
							isProfile={isProfile}
							disabled={disabled}
							onChange={onJobClassChange}
							required={!disabled}
							error={getLMSModuleSettingErrorText(
								errors.moduleSettings,
								'jobClassId',
								t
							)}
							options={data}
							loading={loading}
						/>
						<UserRoleField
							value={values.moduleSettings?.userRoleId}
							isProfile={isProfile}
							disabled={disabled}
							onChange={onUserRoleChange}
							required={!disabled}
							error={getLMSModuleSettingErrorText(
								errors.moduleSettings,
								'userRoleId',
								t
							)}
						/>
					</>
				)}
			</ModuleSettingsContainer>
		</Layout>
	);
};

export default ModuleSettings;
